<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<div class="cement1">大润发购物卡</div>
				<div class="flex-contact-slices" @click="cloem">
					<img src="@/assets/contact_slices/Vector@2x (8).png" style="width: 14px; height: 14px" />
					<div class="assets-return">返回</div>
				</div>
			</div>
			<div class="order-id">
				<div class="order-title">
					<span style="color: #aaaaaa">订单ID :</span>
					0054494D0120250329161605486
				</div>
				<div class="failed">交易失败</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-user">
				<div class="user-id">
					<div class="user-name">用户ID</div>
					<div class="user-numbeer">343</div>
				</div>
				<div class="user-id">
					<div class="user-name">卡号密码</div>
					<div class="user-numbeer">805723/2070249101011061064</div>
				</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-user">
				<div class="user-id">
					<div class="user-name">提交面值</div>
					<div class="user-numbeer" style="color: #EC3925;"><span style="font-size: 12px;">￥</span>1000.00</div>
				</div>
				<div class="user-id">
					<div class="user-name">回收价</div>
					<div class="user-numbeer"><span style="font-size: 12px;">￥</span>1000.00</div>
				</div>
			</div>
			<div class="flex-user" style="margin-top: 16px;">
				<div class="user-id">
					<div class="user-name">实际面值</div>
					<div class="user-numbeer"><span style="font-size: 12px;">￥</span>1000.00</div>
				</div>
				<div class="user-id">
					<div class="user-name">实付金额</div>
					<div class="user-numbeer"><span style="font-size: 12px;">￥</span>0.00</div>
				</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-user" style="margin-top: 16px;">
				<div class="user-id">
					<div class="user-name">提交时间</div>
					<div class="user-numbeer">2025-03-29 16:16:06</div>
				</div>
				<div class="user-id">
					<div class="user-name">处理时间</div>
					<div class="user-numbeer">2025-03-29 16:16:06</div>
				</div>
			</div>
			<div class="flex-user" style="margin-top: 16px;">
				<div class="user-id">
					<div class="user-name">处理结果</div>
					<div class="user-numbeer">--</div>
				</div>
				<div class="user-id">
					<div class="user-name">支付方式</div>
					<div class="user-numbeer">--</div>
				</div>
			</div>
		</div>
		<div style="height: 100px;"></div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

let ids = ref(1);
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement1 {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1 {
	margin-top: 80px;
}
.title-tots {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector {
	width: 94%;
	background: #fff5f5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd {
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #db8a8a;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}

.positioning {
	position: relative;
	margin-left: 11px;
}
.settlement {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ff2f17;
	font-style: normal;
	text-transform: none;
	position: absolute;
	top: 6px;
	left: 16px;
}

.cash-amount {
}
.cash-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.cash-price {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ec3925;
	font-style: normal;
	text-transform: none;
	margin-top: 10px;
}
.withdrawal1 {
	width: 139px;
	height: 42px;
	background: #ff2f17;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 9px;
}

.flex-right-paynces {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flex-rightTap {
	display: flex;
	align-items: center;
	margin-left: -34px;
}

.flex-rightTap1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 54px;
}

.all-title1 {
	color: #ec3925;
}

.flex-date-filter {
	display: flex;
	align-content: center;
	align-items: center;
	margin-top: -16px;
}

.date-filter {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-right: 10px;
}

.query-title {
	width: 52px;
	height: 32px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 11px;
}

.border-top4 {
	width: 29px;
	height: 2px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.border-top3 {
	width: 29px;
	height: 2px;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.flex-date-type {
	display: flex;
}

.Orders-pending {
	margin-top: 32px;
	margin-left: 12px;
	display: flex;
	align-items: flex-end;
}
.order-number {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 24px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.order-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.border-taops {
	width: 1px;
	height: 18px;
	border-left: 1px solid #eeeeee;
	padding-right: 43px;
	margin-left: 43px;
}

.order-id {
	display: flex;
	margin-top: 9px;
}
.order-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #000;
	font-style: normal;
	text-transform: none;
}
.failed {
	width: 68px;
	height: 23px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #ffffff;
	line-height: 23px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 27px;
}
.flex-user{
	display: flex;
}
.user-id{
	width: 256px;
}
.user-name {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}
.user-numbeer {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
</style>
